import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { inputTime } from './pipes/input-time.pipe';
import { MatMenuModule } from '@angular/material/menu';
import { SanitizeTextPipe } from './pipes/sanitize-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterByPropertyPipe } from './pipes/filter-by-property.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReplaceNegativePipe } from './pipes/replace-negative.pipe';
import { ParseIntPipe } from './pipes/parse-int.pipe';
import { AlarmGridTagPipe } from './pipes/alarm-grid-tag.pipe';
import { AlarmGridTitlesPipe } from './pipes/alarm-grid-titles.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { PopupCookiesComponent } from './components/popup-cookies/popup-cookies.component';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { GroundTriangleComponent } from './components/ground-triangle/ground-triangle.component';
import { App360SharedModule } from '@nutricontrol/app360-shared';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    RouterModule,
    MatExpansionModule,
    MatTabsModule,
    MatMenuModule,
    MatInputModule,
    MatTableModule,
    MatTooltipModule,
    NgxPaginationModule,
    App360SharedModule,
    MainHeaderComponent,
    inputTime,
    SanitizeTextPipe,
    SafeHtmlPipe,
    ParseIntPipe,
    FilterByPropertyPipe,
    ReplaceNegativePipe,
    AlarmGridTagPipe,
    AlarmGridTitlesPipe,
    SortPipe,
    PopupCookiesComponent,
    GroundTriangleComponent,
  ],
  exports: [
    MainHeaderComponent,
    inputTime,
    SanitizeTextPipe,
    SafeHtmlPipe,
    FilterByPropertyPipe,
    SortPipe,
    PopupCookiesComponent,
    GroundTriangleComponent,
    ParseIntPipe,
  ],
  providers: [MainHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppCommonsModule {}
